<template>
    <div class="appendix_list">
        <button v-if="thisFileID != '0'" class="attachmentReturnBtn iconfont iconfanhui" @click="attachmentReturn">
            返回上一级
        </button>
        <ul>
            <template v-for="(item, index) in attachmentData">
                <li
                    :key="`attachment_${index}`"
                    @click="attachmentPreview(item)"
                    :class="{'folder':item.FileType == '1', 'file': item.FileType == '2'}"
                >
                    <span class="iconfont fileIcon" :class="addClassName(item)"></span>
                    <div class="fileInfo">
                        <p class="fileName">
                            {{ item.FileName }}
                        </p>
                        <p v-if="item.FileType !== '1'">
                            <em>{{ item.CreateDate || '暂无日期' }}</em>
                            <em v-if="item.FileType !== '1'">
                                <template v-if="item.FileSize > 1048576">
                                    {{ (item.FileSize/1048576).toFixed(2) }}M
                                </template>
                                <template v-else-if="item.FileSize < 1048576 && item.FileSize > 1024">
                                    {{ (item.FileSize/1024).toFixed(2) }}k
                                </template>
                                <template v-else>
                                    {{ item.FileSize }}b
                                </template>
                            </em>
                        </p>
                    </div>
                    <i class="iconfont iconfanhui1"></i>
                </li>
            </template>
        </ul>
    </div>
</template>

<script>
import { ImagePreview } from 'vant';
export default {
    name: 'procurement-catalog',
    components: {},
    data() {
        return {
            // 显示附件数据
            attachmentData: [
                {
                    FileType: '2',
                    FileName: '合同信息',
                    FileSize: 100000000,
                    CreateDate: '2024-02-02',
                },
                {
                    FileType: '1',
                    FileName: '222222222',
                    FileSize: 10000000,
                    CreateDate: '2024-02-02',
                },
            ],
            // 所有附件数据
            allAttachmentData: [],
            thisFileID: '0',
        };
    },
    watch: {},
    created() {},
    mounted() {},
    computed: {},
    methods: {
        // 附件返回上一级
        attachmentReturn() {
            const new_ParentID = this.allAttachmentData.filter(item => item.FileID === this.thisFileID)[0].ParentID;
            this.attachmentData = this.allAttachmentData.filter(item => item.ParentID === new_ParentID);
            this.thisFileID = this.attachmentData[0].ParentID;
        },
        // 附件预览
        attachmentPreview(data) {
            if (data.FileType !== '1') {
                this.$router.isBack = 2;
                const fileFormat = data.FileName.substring(data.FileName.length - 4, data.FileName.length);
                if (
                    fileFormat.indexOf('jpg') > -1
                    || fileFormat.indexOf('png') > -1
                    || fileFormat.indexOf('gif') > -1
                    || fileFormat.indexOf('jpeg') > -1
                ) {
                    this.url = `${this.GLOBAL.FILE_BASE_URL}file-manage/${data.AFI_Code}/download`;
                    ImagePreview({
                        images: [this.url],
                        closeable: true,
                    });
                } else {
                    this.url = `${this.GLOBAL.FILE_BASE_URL}file-manage/preview/${data.AFI_Code}`;
                    this.$router.push({
                        name: 'attachmentPreview',
                        params: {
                            url: this.url,
                            isNews: this.isNews,
                        },
                    });
                }
            } else {
                this.thisFileID = data.FileID;
                this.attachmentData = this.allAttachmentData.filter(item => item.ParentID === data.FileID);
            }
        },
        // 附件图标
        addClassName(item) {
            let className = '';
            if (item.FileType === '1') {
                className = 'sm-fujian';
            } else if (item.FileType === '0') {
                if (/png/i.test(item.FileName)) {
                    className = 'sm-tupian';
                } else if (/jpg/i.test(item.FileName)) {
                    className = 'sm-tupian';
                } else if (/gif/i.test(item.FileName)) {
                    className = 'sm-tupian';
                } else if (/pdf/i.test(item.FileName)) {
                    className = 'sm-pdf1';
                } else if (/docx/i.test(item.FileName)) {
                    className = 'sm-bg-word';
                } else if (/xlsx/i.test(item.FileName)) {
                    className = 'sm-xls';
                } else if (/ppt/i.test(item.FileName)) {
                    className = 'sm-ppt';
                } else if (/txt/i.test(item.FileName)) {
                    className = 'sm-txt';
                } else {
                    className = 'sm-ppt';
                }
            }
            return className;
        },
        // 附件数据处理
        processingAttachmentData(data) {
            const folderData = data.filter(item => item.ParentID === '0');
            if (folderData.length > 0) {
                this.attachmentData = folderData;
            } else {
                this.attachmentData = data;
            }
        },
    },
    updated() {},
    destroyed() {},
};
</script>

<style lang="stylus" scoped>
    .appendix_list
        .attachmentReturnBtn
            width 100%
            height: 30rpx
            border 1px solid #91D5FF
            background: #E6F7FF
            font-size 12rpx
            color #1890FF
        ul
            li
                display flex
                align-items center
                width 100%
                padding 12rpx
                border-bottom 1px solid #ebedf0
                >i
                    line-height: 50rpx
                    width 30rpx
                    text-align: right
                    display: none
                &.folder
                    i
                        display: block
                &.file
                    .fileInfo
                        width calc(100% - 50rpx)
        .fileName
            width 100%
            white-space nowrap
            text-overflow ellipsis
            overflow hidden
        .fileIcon
            font-size 16rpx
            width 50rpx
            text-align center
            height 50rpx
            line-height 50rpx
            &:first-child
                font-size 26rpx
            &:last-child
                font-size 14rpx
                color #979EA7
            &.sm-tupian::before
                color rgba(133, 115, 226, 1)
            &.sm-pdf1::before
                color rgba(255, 85, 98, 1)
            &.sm-bg-word::before
                color rgba(84, 141, 254, 1)
            &.sm-xls::before
                color rgba(72, 203, 129, 1)
            &.sm-ppt::before
                color rgba(255, 147, 51, 1)
            &.sm-txt::before
                color #f60
        .fileInfo
            width calc(100% - 50rpx)
            p
                font-size 16rpx
                color #000
                line-height 24rpx
                &:last-child
                    display flex
                    justify-content space-between
                    em
                        font-size 14rpx
                        color #979EA7
</style>
